import React, { useRef, useEffect } from "react";
import { lang } from "../../../middleware/lang";

const ProductsRow = ({
  selectedCat,
  title,
  products,
  addFunction,
  tiggerAdded,
  selectedProductId,
}) => {
  const hasProducts = Object.keys(products).length > 0;
  const hiddenByCat = selectedCat !== null && !selectedCat;

  if (!hasProducts || hiddenByCat) return null;

  return (
  <div
    className="material_card card_xs_none mb-3 py-3 row pos_products_row"
  >
    <div className="col-12 mb-1">
      <h2>{title}</h2>
    </div>
    <div className="col-12  flex-wrap d-flex">
      {Object.keys(products).map((key, index) => {
        let res = [];
        res.push(
          <Product
            key={key}
            info={products[key]}
            addFunction={addFunction}
            tiggerAdded={tiggerAdded}
            isSelected={selectedProductId === products[key].id}
          />
        );
        return res;
      })}
    </div>
  </div>
  );
};

const Product = ({ info, addFunction, tiggerAdded, isSelected }) => {
  const ref = useRef(null);

  useEffect(() => {
    if (isSelected && ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }
  }, [isSelected]);

  return (
  <div
    ref={ref}
    className={`card product_card full_link_parent  ${
      info.snoozed ? "opacity_6 hover_blocked" : "hover_pointer"
    }`}
    data-product_id={+info.id}
    onClick={info.snoozed ? undefined : addFunction}
    style={
      isSelected
        ? {
            outline: "3px solid #FFBB28",
            outlineOffset: "-3px",
            boxShadow: "0 0 8px rgba(255, 187, 40, 0.5)",
          }
        : undefined
    }
  >
    {tiggerAdded === info.id && (
      <div className="added_card">
        <i className="fas fa-check"></i>
      </div>
    )}
    <div className="img_price">
      <img
        alt={info.title}
        src={
          info.images && info.images.length > 0
            ? info.images[0].url
            : "https://s3.amazonaws.com/ftp-foo/page_assets/no_photo_02.jpg"
        }
        data-holder-rendered="true"
        className="w-100"
      />
      <h5 className="price_tag">
        {info.has_size
          ? lang("Precio por Tamaño", "Price by Size")
          : `$${info.price}`}
      </h5>
    </div>
    <h5 className="my-2" id="product_title_1090">
      {info.title}
    </h5>

    {info.snoozed ? (
      <h6 className="my-2">
        <small className={`text-danger float-lg-right `}>
          <i className="fas fa-stopwatch" aria-hidden="true"></i>Agotado
        </small>
      </h6>
    ) : null}
  </div>
  );
};

export default ProductsRow;
